<template>
  <div>
    <el-form size="mini">
      <el-form-item label="发布链接" label-width="100px">
        <div v-for="(item,index) in formData.publish_link"
             :key="index + 'publish_link'"
             style="margin-bottom: 16px;">
          <el-input class="el-input-c" v-model="formData.publish_link[index]"
                    placeholder="请输入发布链接" maxlength="300"
                    show-word-limit style="width: 600px" clearable></el-input>
          <template>
            <div style="display: inline">
              <el-button
                  @click="formData.publish_link.push('')"
                  style="margin-left: 16px;display: inline"
                  :style="{pointerEvents: index + 1 === formData.publish_link.length ? 'all' : 'none',  opacity: index + 1 === formData.publish_link.length ? 1 : 0}"
                  icon="el-icon-plus"
                  circle
              >
              </el-button>
              <el-button v-if="formData.publish_link.length > 1"
                         @click="delRow(index)"
                         style="margin-left: 16px;display: inline"
                         type="danger"
                         circle
                         icon="el-icon-delete"
              >
              </el-button>
            </div>
          </template>
        </div>
      </el-form-item>
      <el-form-item label-width="100px" v-if="userAuth.can_exec_adv_order" style="text-align: left">
        <el-button type="primary" @click="saveLink" :disabled="loadingSubmit" :loading="loadingSubmit">保存链接
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {savePublishLink} from "@/api/adOrder";

export default {
  name: "PublishLinkForm",
  props: {
    formData: {
      type: Object
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth
    },
    //是否可修改
    canExec() {
      //时间还在当月
      return this.formData.bool_exec === 0 || this.forceEditExecTime
    }
  },
  data() {
    return {
      loadingSubmit: false
    }
  },
  methods: {
    delRow(index) {
      if (this.formData.publish_link)
        this.formData.publish_link.splice(index, 1)
    },
    saveLink() {
      let that = this
      this.$msgbox.confirm(
          "确认保存【发布链接】信息？",
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(() => {

        this.loadingSubmit = true
        //保存发布链接
        let postData = {
          id: this.formData.id, // 订单ID
          publish_link: this.formData.publish_link, // 发布链接
        }
        savePublishLink(postData).then(res => {
          if (res.success) {
            that.showToast({
              title: '提交成功',
              h: that
            })
          }
          that.$emit('loadFormData')
          this.loadingSubmit = false
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });

    }
  }
}
</script>

<style scoped>

</style>